import { RoomKind } from '@thehotelsnetwork/agent-types';

/**
 * Return the type of room supported by THN
 *
 * @param roomName Name of the type of room
 * @return The available type of room supported by THN
 */
const getRoomType = (roomName = '') => {
    const name = roomName.toLowerCase();
    if (name.includes('suite')) {
        return RoomKind.Suite;
    }
    if (name.includes('superior')) {
        return RoomKind.Superior;
    }
    return RoomKind.Standard;
};

export { getRoomType as g };
